import {CPSConstants} from "commonUtils/enumerations";

export const ContactStyle = {
  CloseIcon: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    position: "absolute",
    right: "0.5rem",
    top: "0.5rem",
    color: "#1D2C6E",
  },
  Icon: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    width: "1.2rem",
    paddingTop: "0.313rem",
  },
  TypoGraphyTitle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    fontSize: CPSConstants.FONTREMTEXT,
    opacity: 1,
    color: "#000000",
    marginBottom: "0.25rem",
    fontWeight: "medium",
  },
  TypoGraphyAddress: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    fontSize: CPSConstants.FONTREMTEXT,
    opacity: 1,
    color: "#1F0B0B",
    marginBottom: "1.25rem",
    fontWeight: "medium",
  },
  Link: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    fontSize: CPSConstants.FONTREMTEXT,
    opacity: 1,
    color: "#1D2A69",
  },
  GridItem: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    display: "flex",
    gap: "1rem",
    alignItems: "start",
    justifyContent: "flex-start",
  },
  extratext: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    color: "#1F0B0B",
    fontSize: CPSConstants.FONTREMTEXT,
    fontWeight: CPSConstants.FONTWEIGHT,
  },
};
